import { render, staticRenderFns } from "./addPolicy.vue?vue&type=template&id=60668be6&scoped=true"
import script from "./addPolicy.vue?vue&type=script&lang=js"
export * from "./addPolicy.vue?vue&type=script&lang=js"
import style0 from "./addPolicy.vue?vue&type=style&index=0&id=60668be6&prod&lang=scss&scoped=true"
import style1 from "./addPolicy.vue?vue&type=style&index=1&id=60668be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60668be6",
  null
  
)

export default component.exports